<mat-card *ngIf="editOwnerData" class="owner-card">
  <form #inspForm="ngForm">

    <!-- HEADER -->
    <mat-toolbar class="owner-toolbar">
      <span style="width:90%">Owner</span>
      <span class="fill-remaining-space"></span>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="assignVehicles(editOwnerData.id)" matTooltip="Add owner">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button (click)="desar()" matTooltip="Desar">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Tancar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <!-- CONTINGUT -->
    <div class="owner-content">

      <!-- FORMULARI -->
      <div class="owner-form">

        <mat-form-field appearance="outline">
          <mat-label>Id</mat-label>
          <input
            matInput
            name="id"
            [(ngModel)]="editOwnerData.id"
            [matAutocomplete]="autoId"
            required>
        </mat-form-field>

        <mat-autocomplete #autoId="matAutocomplete">
          <mat-option *ngFor="let id of idList" [value]="id.value">
            {{ id.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
           <input
            matInput
            name="name"
            [(ngModel)]="editOwnerData.name"
            [matAutocomplete]="autoName"
            required>
        </mat-form-field>

        <mat-autocomplete #autoName="matAutocomplete">
          <mat-option *ngFor="let id of idName" [value]="id.value">
            {{ id.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select name="color" [(ngModel)]="editOwnerData.type">
            <mat-option *ngFor="let c of idType" [value]="c.value">
              {{ c.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Adress</mat-label>
          <input matInput type="text"
                 name="adress"
                 [(ngModel)]="editOwnerData.address">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Start date</mat-label>
          <input matInput type="text"
                 name="start_date"
                 [(ngModel)]="editOwnerData.start_date">
        </mat-form-field>

    </div>

      <!-- TARGETA VISUAL -->
      <div class="owner-preview">
        <img src="assets/imatges/grenada_owners.jpg" alt="Owners">
        <h3>{{ editOwnerData.id || '—' }}</h3>
        <p>{{ editOwnerData.name }}</p>
      </div>
    </div>
  </form>
</mat-card>
